import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class Configurator{
	constructor(props){
		const {houseTypeSlug, tourUrl, configuratorUrl, videoUrl, 
			galleryUrl, chooseYourStyleVideoUrl, chooseYourStyleIframeUrl, floorPlansIframeUrl}=props;
		this._houseTypeSlug = houseTypeSlug;
		this._tourUrl = tourUrl;
		this._videoUrl = videoUrl;
		this._configuratorUrl = configuratorUrl;
		this._galleryUrl = galleryUrl;
		this._chooseYourStyleVideoUrl = chooseYourStyleVideoUrl;
		this._chooseYourStyleIframeUrl = chooseYourStyleIframeUrl;
		this._floorPlansIframeUrl = floorPlansIframeUrl;
	}
	get houseTypeSlug(){
		return this._houseTypeSlug;
	}
	get tourUrl(){
		return this._tourUrl;
	}
	get videoUrl(){
		return this._videoUrl;
	}
	get configuratorUrl(){
		return this._configuratorUrl;
	}
	get galleryUrl(){
		return this._galleryUrl;
	}
	get chooseYourStyleVideoUrl(){
		return this._chooseYourStyleVideoUrl;
	}
	get chooseYourStyleIframeUrl(){
		return this._chooseYourStyleIframeUrl;
	}
	get floorPlansIframeUrl(){
		return this._floorPlansIframeUrl;
	}
	static fromJSON(jObject){
		return new Configurator(jObject);
	}
}